// The Auremin symbol - the A - as drawn in the brand guidelines (May 2026, section 2.1), for the
// bar's mark and the wall. The path is the brandbook's SVG byte for byte; only the root differs:
// it fills with currentColor so the surface it sits on colours it from the palette (navy on
// white, white on navy), and it is named for a screen reader, because a symbol that stands for
// the company is not decoration. The size is the caller's, in the units of the surface.

export default function AureminSymbol({ size = 28 }) {
  return (
    <svg className="auremin-symbol" viewBox="0 0 150 156" width={Math.round((size * 150) / 156)} height={size}
         fill="currentColor" role="img" aria-label="Auremin" focusable="false">
      <path d="M109.142 62.0893L98.4764 33.0738L89.9891 10H60.0109L51.5236 33.0738L40.8581 62.0893L10 146H31.905L52.6386 86.3184L61.6057 109.897H88.3942L97.3614 86.3184L118.095 146H140L109.142 62.0893ZM77.1971 92.6091H72.8029L61.9633 62.2827L72.9958 31.5648H77.0042L88.0367 62.2827L77.1971 92.6091Z" />
    </svg>
  );
}
